import { Component } from '@angular/core';
import { ToggleService } from '../../shared/services/toggle.service';

@Component({
  selector: 'app-videos-wrapper',
  template: `
    @if (isBunny) {
      <app-bunny-videos />
    } @else {
      <app-candidate-story />
    }
  `,
  standalone: false
})
export class VideosWrapperComponent {
  isBunny: boolean;

  constructor(toggleService: ToggleService) {
    this.isBunny = toggleService.isEnabled('bunny');
  }
}
